import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const FormBuilderService =  {
    list: async () => axios.get(API_KEEPER + "/generic-form-builder/list").then(({data}) => data).catch((err) => { throw err }),

    listByModule: async (module) => axios.get(API_KEEPER + "/generic-form-builder/list-by-module/" + module).then(({data}) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/generic-form-builder/" + id).then(({data}) => data).catch((err) => { throw err }),

    getAll: async () => axios.get(API_KEEPER + "/generic-form-builder/get-all").then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_KEEPER + `/generic-form-builder`, data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (data, id) => axios.put(API_KEEPER + `/generic-form-builder/${id}`, data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_KEEPER + `/generic-form-builder/${id}`).then(({data}) => data).catch((err) => { throw err }),

    submission: async (data) => axios.post(API_KEEPER + `/generic-form-submissions`, data).then(({data}) => data).catch((err) => { throw err }),

    submissionList: async (templateId, externalId) => {
        const formData = new FormData();
        formData.append("externalId", externalId || null)

        return axios.post(API_KEEPER + `/generic-form-submissions/list/${templateId}`, formData,{headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then(({data}) => data)
            .catch((err) => {throw err})
    },

    modules: async () => axios.get(API_KEEPER + "/generic-form-builder/module-list").then(({data}) => data).catch((err) => { throw err }),

    preview: async (formData) => axios.post(API_KEEPER + "/generic-form-submissions/preview",  formData, {responseType: "blob"}).then(({data}) => data).catch((err) => { throw err })
};

export default FormBuilderService;